import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Nav, NavItem } from 'react-bootstrap';
import NavLink from 'components/NavLink';
import { logout } from 'actions/user';

class AuthMenu extends Component {
  onLogoutClick = () => {
    const { user, logout, history } = this.props;
    const redirectUrl = user.isStaff || user.isAccountant ? '/login' : '/home';

    logout(() => {
      history.push(redirectUrl);
    });
  };

  render() {
    if (this.props.isAuth) {
      return (
        <div id="nav-logout">
          <Nav pullRight>
            <NavItem onClick={this.onLogoutClick}>
              <NavLink glyphIcon="log-out" title="Logout" />
            </NavItem>
          </Nav>
        </div>
      );
    }

    return null;
  }
}

AuthMenu.propTypes = {
  isAuth: PropTypes.bool
};

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  { logout }
)(AuthMenu);



// WEBPACK FOOTER //
// ./src/components/MainMenu/AuthMenu.js